import { IQuery, IQueriedDatasource, IDatasourceReportFn } from 'core-ts-types';

export interface IMemberDatasource {
  branding: {
    header_logo: string;
    footer_logo: string;
    favicon: string;
    first_header_bar_color: string;
    first_header_bar_height: string;
    second_header_bar_color: string;
    header_logo_background_color: string;
    header_logo_height: string;
    header_logo_width: string;
    header_logo_placement: string;
    footer_color: string;
    footer_height: string;
    footer_logo_width: string;
    footer_logo_margin: string;
    primary_color: string;
  };
  core_config: {
    full_name: string;
    short_name: string;
    indefinite_article: string; // from English grammar, i.e. "a" or "an"
    university_url: string;
    privacy_policy_url: string;
    google_captcha_site_key: string;
    enable_course_equivalency_view: boolean;
    enable_additional_course_info: boolean;
  };
  google_tag_manager: {
    is_enabled: boolean;
    id: string;
  };
  platform_analytics: {
    is_enabled: boolean;
  };
}

export class MemberDatasource implements IQueriedDatasource {
  public __queries__: IQuery[];
  private _source: IMemberDatasource;

  constructor() {
    this.initialize();
  }

  initialize(): MemberDatasource {
    this._source = {
      branding: {
        header_logo: '',
        footer_logo: '',
        favicon: '',
        first_header_bar_color: '',
        first_header_bar_height: '',
        second_header_bar_color: '',
        header_logo_background_color: '',
        header_logo_height: '',
        header_logo_width: '',
        header_logo_placement: '',
        footer_color: '',
        footer_height: '',
        footer_logo_width: '',
        footer_logo_margin: '',
        primary_color: ''
      },
      core_config: {
        full_name: '',
        short_name: '',
        indefinite_article: '', // from English grammar, i.e. "a" or "an"
        university_url: '',
        privacy_policy_url: '',
        google_captcha_site_key: '',
        enable_course_equivalency_view: false,
        enable_additional_course_info: false
      },
      google_tag_manager: {
        is_enabled: false,
        id: ''
      },
      platform_analytics: {
        is_enabled: false
      }
    };
    return this;
  }

  write(source: any): MemberDatasource {
    this._source.branding = source.branding;
    this._source.core_config = source.core_config;
    this._source.platform_analytics = source.platform_analytics;
    this._source.google_tag_manager = source.google_tag_manager;
    return this;
  }

  report(fn: IDatasourceReportFn): any {
    return fn(this._source);
  }

  read(): IMemberDatasource {
    return this._source;
  }
}

angular.module('capability-ng-global').service('ngMemberDatasource', MemberDatasource);



// WEBPACK FOOTER //
// ./app/lib/global/datasources/member_datasource.ts